export interface TimePeriod {
  label: string;
  value: string;
}

export const TIME_PERIODS: TimePeriod[] = [
  { label: 'Today', value: 'today' },
  { label: 'Yesterday', value: 'yesterday' },
  { label: 'Last 7 Days', value: 'last7days' },
  { label: 'Last 30 Days', value: 'last30days' },
  { label: 'All Time', value: 'all' }
];